import * as LogService from '../core/services/logservice/log.service';
import * as HttpDataServiceBase from '../core/httpdataservicebase';
import * as MessageBarService from '../core/services/messageBarService/messageBar.service';
import * as Model from '../models/models';
import IAppSettings from '../../iApp.settings';

export class VerticalRepository extends HttpDataServiceBase.DataServiceBase<Model.IVertical> {
    static $inject = ['$q', '$http', 'logService', 'appSettings', 'messageBarService'];
    constructor($q: ng.IQService, $http: ng.IHttpService, logger: LogService.ILogService, appSettings: IAppSettings, messageBarService: MessageBarService.MessageBarService) {
        super($q, $http, logger, messageBarService, appSettings.apiPath + '/brands');
        this.appSettings = appSettings;
    }

    private appSettings: IAppSettings;

    public getVerticals(): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/verticals`;

        return this.$http.get(url)
            .then((response: ng.IHttpPromiseCallbackArg<Model.IVertical[]>) => {
                return this.successHandler(response);
            })
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }
}